import styled from 'styled-components';
import { Button } from 'ui-components/src/components/atoms/Button';
import { CrossIcon } from 'ui-components/src/components/atoms/icons/CrossIcon';
import { NextAngle } from 'ui-components/src/components/atoms/icons/NextAngle';

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.header`
  display: flex;
`;

export const HeaderContent = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.lightGrey}`};
`;

export const CloseButton = styled.button`
  width: 65px;
  height: 65px;
  background-color: ${({ theme }) => theme.colors.lightBlue};
  border: 0;
  outline: 0;
  cursor: pointer;

  &:hover {
    filter: brightness(0.9);
  }
`;

export const CloseIcon = styled(CrossIcon)`
  height: 1rem;
  width: 1rem;
  fill: ${({ theme }) => theme.colors.white};
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const NavSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const NavItem = styled.a<{ selected?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-decoration: none;
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.darkGrey};
  padding: 1rem 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightestGray};
  background-color: ${({ selected, theme }) =>
    selected ? theme.colors.lightestGray : undefined};

  &:hover {
    background-color: ${({ theme }) => theme.colors.lightestGray};
  }
`;

export const StyledArrowIcon = styled(NextAngle)`
  color: ${({ theme }) => theme.colors.midBlue};
`;

export const UserSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Username = styled.div`
  text-align: center;
`;

export const LogoutButton = styled(Button)`
  font-family: NLRTM;
  margin: 1rem auto;
  padding: 0 2rem;
`;

export const UserAgreementSection = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 0.5rem;
`;
